import React from 'react';

import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { getFormatedMoneyIn, getFormatedMoneyOut } from '@helpers/andesUtils';

import { theme } from 'fpay-ui';

const fontTypes = {
  title: css`
    ${({ theme }) => theme.textTypes['Subtitle-1-w500']};
    letter-spacing: 0.32px;
    line-height: normal;
    color: ${theme.colors.gray700};
  `,
  description: css`
    ${({ theme }) => theme.textTypes['Body-2-w500']};
    line-height: normal;
    color: ${theme.colors.gray800};
  `,
  titleTable: css`
    ${({ theme }) => theme.textTypes['Caption-w400']};
    line-height: normal;
    color: ${theme.colors.gray800};
  `,
};

const Layout = styled.div`
  padding-left: 12px;
  padding-right: 12px;
`;

const Title = styled.div`
  ${fontTypes.title}
  margin-bottom: 8px;
`;

const Description = styled.div`
  ${fontTypes.description}
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 296px;
`;

const Line = styled.div`
  border-top: 2px solid ${theme.colors.gray300};
  width: 100%;
  margin-bottom: 15px;
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ColTitle = styled.div`
  display: flex;
  ${fontTypes.titleTable}
  margin-bottom: 4px;
`;

const ColDescription = styled.div`
  display: flex;
  ${fontTypes.description}
  margin-bottom: ${(props) => (props.bottom ? '24px' : '16px')};
`;

const ModalAdvancements = ({
  description,
  advancedGrossAmount,
  discountRate,
  advancedDiscountAmount,
  advancedNetAmount,
  date,
  code,
}) => {
  const { t } = useTranslation();

  return (
    <Layout>
      <Title>{t('modalTable.modal.title')}</Title>
      <Description>{description}</Description>
      <Line />
      <Table>
        <Row>
          <ColTitle>{t('lastMovements.type')}</ColTitle>
          <ColTitle>{t('lastMovements.advancementMount')}</ColTitle>
        </Row>
        <Row>
          <ColDescription>{t('lastMovements.advancementSolicited')}</ColDescription>
          <ColDescription>{getFormatedMoneyIn(advancedGrossAmount)}</ColDescription>
        </Row>
        <Row>
          <ColDescription>
            {t('lastMovements.advancementCom')} ({discountRate * 100}%)
          </ColDescription>
          <ColDescription>{getFormatedMoneyOut(Math.abs(advancedDiscountAmount))}</ColDescription>
        </Row>
        <Row>
          <ColDescription bottom>{t('lastMovements.advancementFinal')}</ColDescription>
          <ColDescription bottom>{getFormatedMoneyIn(advancedNetAmount)}</ColDescription>
        </Row>
        <Row>
          <ColTitle>{t('lastMovements.advancementDate')}</ColTitle>
          <ColTitle>{t('lastMovements.advancementCode')}</ColTitle>
        </Row>
        <Row>
          <ColDescription bottom>{date}</ColDescription>
          <ColDescription bottom>{code}</ColDescription>
        </Row>
      </Table>
    </Layout>
  );
};

export default ModalAdvancements;
